import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hideSideBar } from '../../redux/actions/miscActions'
import { Drawer } from 'antd';
import ProductForm from '../admin/ulits/ProductForm'
import Cart from '../shop/Cart';
import Filters from '../shop/Filters';
import NavIcons from '../layout/NavIcons';
import CustOrders from '../shop/CustOrders';
import PakketFilters from '../shop/PakketFilters';
import PakketForm from '../admin/ulits/PakketForm';
import SideBarNavLinks from '../layout/SideBarNavLinks';


export class SideBar extends Component {
  
    onClose=()=>{
    this.props.hideSideBar()
  }

  render() {
    const { isSideBarVisible, sideBarContent, sideBarPlacement } = this.props.misc
    return (
      <div>
          <Drawer
        placement={sideBarPlacement}
        key={sideBarPlacement}
        closable={false}
        onClose={this.onClose}
        visible={isSideBarVisible}
        className="side-bar"
        destroyOnClose={true}
      >
        {sideBarContent === 'newProductForm' ? <ProductForm />  : null} 
        {sideBarContent === 'newPakketForm' ? <PakketForm /> : null} 
        {sideBarContent === 'cart' ? <Cart /> : null}
        {sideBarContent === 'orders' ? <CustOrders/> : null}        
        {sideBarContent === 'filters' ? <NavIcons /> : null}
        {sideBarContent === 'filters' ? <Filters/> : null}
        {sideBarContent === 'pakketFilters' ? <NavIcons /> : null}
        {sideBarContent === 'pakketFilters' ? <PakketFilters /> : null}
        {sideBarContent === 'main' ? <NavIcons /> : null}
        {sideBarContent === 'main' ? <SideBarNavLinks />: null}
      </Drawer>
             
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc
})

export default connect(mapStateToProps, {hideSideBar})(SideBar)
